export class CorreoDetalleBpm {
    cbpmmailIdcodtip = 'FUR';
    cbpmmaildetAsunto: string;
    cbpmmaildetContenido: string;

    cbpmmaildetDestinatario: string;
    cbpmmaildetEstado = 'Pendiente';
    // cbpmmaildetRemitente: string = "daniel.valderrama27@gmail.com"; // PROVISIONAL
    cbpmmaildetRemitente: string = null; // PROVISIONAL
    // cbpmmaildetRemitente: string = "CGR@gmail.com"; // PROVISIONAL
    nbpmmailIdmail: string;
    nbpmmailIdtipo = 24;
    nbpmmailIntento = 0;
    nbpmmaildetId: string;

}
